/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import useSubscribe, { Subscriber } from '@brands/hooks/useSubscribe';
import { IConversationStatistics } from '@brands/services/communication/listConversationStatistics';
import { IGMConversation } from '@brands/services/communication/types/IGMConversation';
import { IGMConversationParticipant } from '@brands/services/communication/types/IGMConversationParticipant';
import React, { useEffect, useMemo, useState } from 'react';
import { isMobile as mobileDetect } from 'react-device-detect';
import { useParams } from 'react-router-dom';

import styles from './case-styles.module.scss';
import CaseMessageInfo from './CaseMessageInfo';

interface ConversationsListProps {
  activeConversationSid: string | null;
  setActiveConversationSid: (conversationSid: string | null) => void;
  thisCaseId: number | undefined;
  conversations: IConversationStatistics[];
  setCaseId: React.Dispatch<React.SetStateAction<number | undefined>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  changeCaseUnreadIndicator: (case_id: number) => Promise<void>;
  setSelectedConversationParticipants: React.Dispatch<React.SetStateAction<IGMConversationParticipant[]>>;
  setSelectedConversationForMessageBody: React.Dispatch<React.SetStateAction<IGMConversation | undefined>>;
}
const CaseConversationList: React.FC<ConversationsListProps> = ({
  activeConversationSid,
  setActiveConversationSid,
  thisCaseId,
  conversations,
  setCaseId,
  setLoading,
  changeCaseUnreadIndicator,
  setSelectedConversationParticipants,
  setSelectedConversationForMessageBody,
}) => {
  const routeCaseId = useParams().caseId as string;
  const [noConversations, setNoConversations] = useState(false);
  const [displayConversations, setDisplayConversations] = useState<IConversationStatistics[]>([]);

  useEffect(() => {
    setDisplayConversations([]);
    if (conversations && conversations.length > 0) {
      setDisplayConversations(conversations);
      setNoConversations(false);
    }
  }, [conversations]);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!conversations || conversations.length === 0) {
        setNoConversations(true);
      }
    }, 8000);

    return () => clearTimeout(timer);
  }, [conversations]);

  useEffect(() => {
    if (conversations && conversations.length > 0) {
      setNoConversations(false);
    }
  }, [conversations]);
  const roleNavigate = useRoleNavigate();
  const isMobile = mobileDetect;

  const reloadConversationList = (): void => {
    if (!routeCaseId) {
      try {
        if (activeConversationSid) {
          const activeConv = conversations.find((c) => c?.conversation_sid === activeConversationSid);

          if (activeConv) {
            setCaseId(activeConv.case_id);
          } else {
            // conversation not found in current list -> reset
            setActiveConversationSid(null);
            setCaseId(undefined);

            if (conversations[0]?.conversation_sid) {
              const firstId = conversations[0].conversation_sid;
              setActiveConversationSid(firstId);
              setCaseId(conversations[0].case_id);
              roleNavigate(`/messages/${firstId}`);
            }
          }
        } else if (!isMobile) {
          if (conversations[0]?.conversation_sid) {
            const firstConversarionId = conversations[0].conversation_sid;
            setActiveConversationSid(firstConversarionId);
            if (!isMobile) {
              setCaseId(conversations[0]?.case_id);
              roleNavigate(`/messages/${firstConversarionId}`);
            }
          }
        }
      } catch (error) {
        console.error('Error loading conversations:', error);
      }
    }
  };

  useEffect(() => {
    setLoading(true);
    reloadConversationList();
    setLoading(false);
  }, [conversations, routeCaseId]);

  const subscriber: Subscriber = useMemo(
    () => ({
      onMessage: (message: Record<string, any>) => {
        if (thisCaseId && Number(message.case_id) === Number(thisCaseId)) {
          if (['case_new_conversation_created', 'case_new_message_created'].includes(message.command)) {
            changeCaseUnreadIndicator(thisCaseId);
            reloadConversationList();
          }
        }
      },
      commands: ['case_new_message_created', 'case_new_conversation_created'],
    }),
    [thisCaseId, changeCaseUnreadIndicator, reloadConversationList],
  );
  const { subscribe, unsubscribe } = useSubscribe();

  useEffect(() => {
    const subscriptionId = subscribe(subscriber);

    return () => unsubscribe(subscriptionId);
  }, [subscribe, unsubscribe, subscriber]);

  return (
    <div className={styles.vSidenav}>
      <div className={styles.participantsDiv}>
        <div className={styles.vParticipantsInfo}>
          <div className={styles.messagesList}>
            {displayConversations && displayConversations.length > 0 ? (
              displayConversations.map((conversation) => {
                return (
                  <li
                    key={conversation.conversation_sid}
                    className={`${activeConversationSid === conversation.conversation_sid ? styles.selected : ''}
                    ${styles.messagesListList}
                    ${styles.borderBottom}`}
                    onClick={() => {
                      setCaseId(conversation.case_id);
                    }}
                  >
                    <CaseMessageInfo
                      conversation={conversation}
                      isSelected={activeConversationSid === conversation.conversation_sid}
                      isMobile={isMobile}
                      setSelectedConversationParticipants={setSelectedConversationParticipants}
                      setSelectedConversationForMessageBody={setSelectedConversationForMessageBody}
                    />
                  </li>
                );

                return null;
              })
            ) : !noConversations ? (
              <Loading dotted />
            ) : (
              <span className={styles.noConversationSpan}>No Conversation Found.</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseConversationList;
